var _defs, _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMgGroupLogoWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 381.97 189.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mg-group_logoWhite_noBg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.06,260.56a13,13,0,0,1-7.89-2.67A54,54,0,1,1,174,215a13,13,0,1,1-26,0,28,28,0,1,0-45,22.25,13,13,0,0,1-7.91,23.3Z",
    transform: "translate(-66 -161.01)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.05,262a12.91,12.91,0,0,1-7.26-2.23A54,54,0,1,1,256,215a13,13,0,0,1-26,0,28,28,0,1,0-43.66,23.23A13,13,0,0,1,179.05,262Z",
    transform: "translate(-66 -161.01)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.09,262a13,13,0,0,1-7.25-2.22A54,54,0,1,1,338,215a13,13,0,0,1-26,0,28,28,0,1,0-43.63,23.25A13,13,0,0,1,261.09,262Z",
    transform: "translate(-66 -161.01)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401.08,256c.73-.64,1.46-1.29,2.17-2A53.68,53.68,0,0,0,420,216.27a13,13,0,1,0-26-.6A28,28,0,1,1,366,187h1a13,13,0,0,0,.3-26A54,54,0,1,0,364.73,269l1.26,0h0a28,28,0,1,1-28,28,13,13,0,0,0-26,0,54,54,0,1,0,89.08-41Z",
    transform: "translate(-66 -161.01)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 369.99,
    cy: 89.04,
    r: 11.98
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.35,337.38a4,4,0,0,1,1.24-7.89,4,4,0,0,1,1.63.33,22.56,22.56,0,0,0,9.64,2.08c6.77,0,10-3.25,10-9.51V320.7c-2.93,3.52-6.13,5.67-11.4,5.67-8.15,0-15.51-5.93-15.51-16.29V310c0-10.43,7.49-16.29,15.51-16.29,5.4,0,8.6,2.28,11.27,5.21v-.07a5,5,0,0,1,9.9.07v22.48c0,6.25-1.5,10.81-4.43,13.75-3.26,3.25-8.27,4.69-15,4.69A33.43,33.43,0,0,1,84.35,337.38Zm22.48-27.3V310c0-4.76-3.72-8.08-8.54-8.08s-8.47,3.32-8.47,8.08v.13c0,4.82,3.65,8.08,8.47,8.08S106.83,314.83,106.83,310.08Z",
    transform: "translate(-66 -161.01)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.09,298.87a5,5,0,0,1,9.91,0v1.56c1.43-3.38,3.78-6.51,6.71-6.51a4.79,4.79,0,0,1,1.11,9.45c-5,1.17-7.82,5-7.82,12.05v9.25a5,5,0,0,1-9.91,0Z",
    transform: "translate(-66 -161.01)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.7,312v-.13c0-10,8.08-18.18,19-18.18s18.83,8,18.83,18v.13c0,10-8.08,18.17-19,18.17S160.7,322,160.7,312Zm28,0v-.13c0-5.15-3.71-9.65-9.19-9.65-5.67,0-9.05,4.37-9.05,9.52v.13c0,5.14,3.71,9.64,9.18,9.64C185.33,321.48,188.72,317.11,188.72,312Z",
    transform: "translate(-66 -161.01)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.72,324.67a4.95,4.95,0,1,1-9.9,0v-.39c-2.28,2.93-5.21,5.6-10.23,5.6-7.49,0-11.86-4.95-11.86-13V298.87a5,5,0,0,1,9.91,0v14.92c0,4.69,2.21,7.1,6,7.1s6.19-2.41,6.19-7.1V298.87a4.95,4.95,0,0,1,9.9,0Z",
    transform: "translate(-66 -161.01)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.21,298.87a4.95,4.95,0,0,1,9.9,0v.46A12.83,12.83,0,0,1,278,293.66c8.14,0,15.89,6.38,15.89,18v.13c0,11.66-7.62,18-15.89,18a13.44,13.44,0,0,1-10.89-5.21V335.1a4.95,4.95,0,1,1-9.9,0Zm26.78,13v-.13c0-5.8-3.91-9.65-8.54-9.65s-8.47,3.85-8.47,9.65v.13c0,5.79,3.85,9.64,8.47,9.64S284,317.7,284,311.84Z",
    transform: "translate(-66 -161.01)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMgGroupLogoWhite);
export default __webpack_public_path__ + "static/media/mg-group-logo-white.2912dd4280cf3e1d2531fc09ffa8404a.svg";
export { ForwardRef as ReactComponent };